import React from 'react';
import { useQuery } from 'react-fetching-library';
import { getInvoiceTemplateAction } from '../../../services/request';
import AddInvoiceTemplate from './AddInvoiceTemplate';
import InvoiceTemplateList from './InvoiceTemplateList';

export const InvoiceTemplates = () => {
  const [templates, setTemplates] = React.useState([]);
  const [search, setSearch] = React.useState(null);
  const { loading, payload, error } = useQuery(
    getInvoiceTemplateAction('GET', search)
  );

  const queryCallback = (searchVal = null) => {
    setSearch(searchVal);
  };

  React.useEffect(() => {
    if (!loading && !error && payload) {
      setTemplates(payload.results ?? []);
    }
  }, [loading]);

  return (
    <>
      <AddInvoiceTemplate setTemplates={setTemplates} />
      <InvoiceTemplateList
        templates={templates}
        queryCallback={queryCallback}
        setTemplates={setTemplates}
      />
    </>
  );
};

